import { GLOBAL_FOCUS_IDS } from "./constants";
import { SceneInteractivesConfig } from "./types";
import { Scenes } from "../types";
import {
	SPLASH_SCREEN_INTERACTIVES,
	CABIN_HUB_INTERACTIVES,
	CABIN_COUCH_INTERACTIVES,
	CABIN_RADIO_INTERACTIVES,
	CABIN_GAME_TABLE_INTERACTIVES,
	CABIN_LIBRARY_INTERACTIVES,
	CABIN_DESK_INTERACTIVES,
	CABIN_DESK_DRAWER_INTERACTIVES,
	CABIN_EXIT_INTERACTIVES,
	CABANA_INTERACTIVES,
	CABIN_FIREPLACE_INTERACTIVES,
	CABIN_WINDOW_INTERACTIVES,
	CABANA_BEACH_INTERACTIVES,
	CABIN_KITCHEN_INTERACTIVES,
	CABIN_CAT_INTERACTIVES,
	PLANE_INTERACTIVES,
	PLANE_RETURN_INTERACTIVES,
	INTERACTIVE_CAT_INTERACTIVES,
} from "./interactives";
import { navGraphChain as chain } from "./navGraphHelpers";
import { FOCUSABLES } from "./focusables";

export const SCENE_INTERACTIVES: Record<Scenes, SceneInteractivesConfig> = {
	SPLASH_SCREEN: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			NAV_MENU: {
				disable: true,
			},
			INITIAL_FOCUS: FOCUSABLES.SPLASH_SCREEN.ENTER_CABIN,
		},
		INTERACTIVES: SPLASH_SCREEN_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[GLOBAL_FOCUS_IDS.USER_PROFILE, FOCUSABLES.SPLASH_SCREEN.ENTER_CABIN],
				"right",
			),
		],
	},
	CABIN_HUB: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_HUB.RADIO,
		},
		INTERACTIVES: CABIN_HUB_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_HUB.NAV_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_HUB.TV,
					FOCUSABLES.CABIN_HUB.RADIO,
					FOCUSABLES.CABIN_HUB.FIREPLACE,
					FOCUSABLES.CABIN_HUB.OWL,
					FOCUSABLES.CABIN_HUB.LIBRARY,
					FOCUSABLES.CABIN_HUB.CAT,
					FOCUSABLES.CABIN_HUB.WINDOW,
					FOCUSABLES.CABIN_HUB.GAME_TABLE,
					FOCUSABLES.CABIN_HUB.DESK,
					FOCUSABLES.CABIN_HUB.COUCH,
					FOCUSABLES.CABIN_HUB.NAV_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_HUB.NAV_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
			...chain(
				[
					FOCUSABLES.CABIN_HUB.FIREPLACE,
					FOCUSABLES.CABIN_HUB.RADIO,
					FOCUSABLES.CABIN_HUB.TV,
				],
				"up",
			),
			...chain(
				[FOCUSABLES.CABIN_HUB.CAT, FOCUSABLES.CABIN_HUB.LIBRARY, FOCUSABLES.CABIN_HUB.OWL],
				"up",
			),
			...chain([FOCUSABLES.CABIN_HUB.GAME_TABLE, FOCUSABLES.CABIN_HUB.WINDOW], "up"),
			...chain([FOCUSABLES.CABIN_HUB.COUCH, FOCUSABLES.CABIN_HUB.DESK], "up"),
		],
	},
	CABIN_CAT: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_CAT.PET,
		},
		INTERACTIVES: CABIN_CAT_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_HUB.NAV_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_CAT.PET,
					FOCUSABLES.CABIN_CAT.NAV_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_HUB.NAV_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_COUCH: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_COUCH.TABLE,
		},
		INTERACTIVES: CABIN_COUCH_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_COUCH.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_COUCH.TV,
					FOCUSABLES.CABIN_COUCH.RADIO,
					FOCUSABLES.CABIN_COUCH.FIREPLACE,
					FOCUSABLES.CABIN_COUCH.TABLE,
					FOCUSABLES.CABIN_COUCH.OWL,
					FOCUSABLES.CABIN_COUCH.BOOKSHELF,
					FOCUSABLES.CABIN_COUCH.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_COUCH.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
			...chain(
				[
					FOCUSABLES.CABIN_COUCH.TV,
					FOCUSABLES.CABIN_COUCH.RADIO,
					FOCUSABLES.CABIN_COUCH.FIREPLACE,
					FOCUSABLES.CABIN_COUCH.TABLE,
					FOCUSABLES.CABIN_COUCH.ARROW_RIGHT,
				],
				"down",
			),
		],
	},
	CABIN_RADIO: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_RADIO.TOGGLE,
		},
		INTERACTIVES: CABIN_RADIO_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_RADIO.LEFT_ARROW,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_RADIO.TOGGLE,
					FOCUSABLES.CABIN_RADIO.STATION_CHANGE,
					FOCUSABLES.CABIN_RADIO.VOLUME_UP,
					FOCUSABLES.CABIN_RADIO.VOLUME_DOWN,
					FOCUSABLES.CABIN_RADIO.RIGHT_ARROW,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_RADIO.LEFT_ARROW,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_GAME_TABLE: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_GAME_TABLE.CHESS,
		},
		INTERACTIVES: CABIN_GAME_TABLE_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_GAME_TABLE.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_GAME_TABLE.CHESS,
					FOCUSABLES.CABIN_GAME_TABLE.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_COUCH.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_FIREPLACE: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_FIREPLACE.ARROW_LEFT,
		},
		INTERACTIVES: CABIN_FIREPLACE_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_FIREPLACE.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_FIREPLACE.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_FIREPLACE.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_WINDOW: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_WINDOW.ARROW_CENTER,
		},
		INTERACTIVES: CABIN_WINDOW_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_WINDOW.ARROW_CENTER,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_WINDOW.ARROW_CENTER,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_LIBRARY: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_LIBRARY.BOOKSHELF,
		},
		INTERACTIVES: CABIN_LIBRARY_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_LIBRARY.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_LIBRARY.RADIO,
					FOCUSABLES.CABIN_LIBRARY.FIREPLACE,
					FOCUSABLES.CABIN_LIBRARY.BOOKSHELF,
					FOCUSABLES.CABIN_LIBRARY.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_LIBRARY.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
			...chain([FOCUSABLES.CABIN_LIBRARY.RADIO, FOCUSABLES.CABIN_LIBRARY.FIREPLACE], "up"),
		],
	},
	CABIN_DESK: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_DESK.DRAWER,
		},
		INTERACTIVES: CABIN_DESK_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_DESK.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_DESK.DRAWER,
					FOCUSABLES.CABIN_DESK.CARD_CRAFT,
					FOCUSABLES.CABIN_DESK.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_DESK.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
			...chain([FOCUSABLES.CABIN_DESK.DRAWER, FOCUSABLES.CABIN_DESK.CARD_CRAFT], "up"),
		],
	},
	CABIN_DESK_DRAWER: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_DESK_DRAWER.TICKETS,
		},
		INTERACTIVES: CABIN_DESK_DRAWER_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_DESK_DRAWER.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_DESK_DRAWER.TICKETS,
					FOCUSABLES.CABIN_DESK_DRAWER.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_DESK_DRAWER.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_EXIT: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABIN_EXIT.EXIT,
		},
		INTERACTIVES: CABIN_EXIT_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_EXIT.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_EXIT.LAMP,
					FOCUSABLES.CABIN_EXIT.EXIT,
					FOCUSABLES.CABIN_EXIT.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_EXIT.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	CABIN_KITCHEN: {
		UI: {
			INITIAL_FOCUS: FOCUSABLES.CABIN_KITCHEN.ARROW_LEFT,
		},
		INTERACTIVES: CABIN_KITCHEN_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_KITCHEN.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABIN_KITCHEN.ARROW_RIGHT,
				],
				"right",
			),
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					FOCUSABLES.CABIN_KITCHEN.ARROW_LEFT,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
				],
				"up",
			),
		],
	},
	PLANE: {
		UI: {
			USER_PROFILE: {
				isVisible: false,
			},
			NAV_MENU: {
				disable: true,
			},
			INITIAL_FOCUS: FOCUSABLES.PLANE.SKIP_TO_CABANA,
		},
		INTERACTIVES: PLANE_INTERACTIVES,
		NAV_GRAPH: [...chain([FOCUSABLES.PLANE.SKIP_TO_CABANA], "right")],
	},
	PLANE_RETURN: {
		UI: {
			USER_PROFILE: {
				isVisible: false,
			},
			NAV_MENU: {
				disable: true,
			},
			INITIAL_FOCUS: FOCUSABLES.PLANE_RETURN.SKIP_TO_CABIN,
		},
		INTERACTIVES: PLANE_RETURN_INTERACTIVES,
		NAV_GRAPH: [...chain([FOCUSABLES.PLANE_RETURN.SKIP_TO_CABIN], "right")],
	},
	CABANA: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABANA.ARROW_UP,
		},
		INTERACTIVES: CABANA_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABANA.ARROW_UP,
					FOCUSABLES.CABANA.PLANE_RETURN,
				],
				"right",
			),
			...chain(
				[GLOBAL_FOCUS_IDS.HOME, GLOBAL_FOCUS_IDS.BACK, GLOBAL_FOCUS_IDS.USER_PROFILE],
				"up",
			),
		],
	},
	CABANA_BEACH: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.CABANA_BEACH.ARROW_DOWN,
		},
		INTERACTIVES: CABANA_BEACH_INTERACTIVES,
		NAV_GRAPH: [
			...chain(
				[
					GLOBAL_FOCUS_IDS.HOME,
					GLOBAL_FOCUS_IDS.BACK,
					GLOBAL_FOCUS_IDS.USER_PROFILE,
					FOCUSABLES.CABANA_BEACH.ARROW_DOWN,
				],
				"right",
			),
			...chain(
				[GLOBAL_FOCUS_IDS.HOME, GLOBAL_FOCUS_IDS.BACK, GLOBAL_FOCUS_IDS.USER_PROFILE],
				"up",
			),
		],
	},
	INTERACTIVE_CAT: {
		UI: {
			USER_PROFILE: {
				isVisible: true,
			},
			INITIAL_FOCUS: FOCUSABLES.INTERACTIVE_CAT.SKIP,
		},
		INTERACTIVES: INTERACTIVE_CAT_INTERACTIVES,
		NAV_GRAPH: [],
	},
};
